import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { handleIsSameOrBefore } from '../../../../lib/date';
import SubscriptionPremiumDetails from './SubscriptionPremiumDetails';
import SubscriptionTrialDetails from "./SubscriptionTrialDetails";

class SubscriptionDetails extends React.Component {
    _handleTooltipShow = (id) => () => {
      const { showTooltip } = this.props;

      showTooltip(id);
    };

    render() {
      const { trial } = this.props;
      const isBeingTrial = !!(trial  && handleIsSameOrBefore(new Date(), trial));

      return (
        <React.Fragment>{isBeingTrial ? <SubscriptionTrialDetails /> : <SubscriptionPremiumDetails />}</React.Fragment>
      );
    }
}

SubscriptionDetails.propTypes = {
  trial: PropTypes.string
};

const mapStateToProps = (state) => {
  return {
    trial: state.getIn(['currentUser', 'data', 'trialEndsAt'])
  };
};

export default connect(mapStateToProps)(SubscriptionDetails);



// WEBPACK FOOTER //
// ./app/components/reps/settings/subscription/SubscriptionDetails.jsx